var map = {
	"./APFEL.svg": 297,
	"./BONBON.svg": 911,
	"./BUTTER.svg": 823,
	"./HAHN.svg": 515,
	"./HUND.svg": 328,
	"./KARTOFFEL.svg": 903,
	"./KNEIFEN.svg": 933,
	"./KUSS.svg": 246,
	"./Leg.svg": 397,
	"./LÖWENZAHN.svg": 829,
	"./OHRFEIGE.svg": 25,
	"./PFÜTZE.svg": 910,
	"./PUPPE.svg": 872,
	"./QUETSCHFLECK.svg": 181,
	"./RÜCKEN.svg": 950,
	"./SCHAUKELN(VERB).svg": 176,
	"./SOFA.svg": 560,
	"./ZWIEBEL.svg": 194,
	"./walkingPerson.svg": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 567;